'use client';

import React from 'react';
import Link from 'next/link';
import Box from '@mui/material/Box';
import { AuthContext } from '@/context/create-context';
import { useClintMediaQuery } from '@/utils/hooks/useClintMediaQuery';
import {
  CANDIDATES_ME_ROUTER_PATH,
  CULTURAL_ROUTER_PATH,
  HOME_PAGE_ROUTER_PATH,
  TERMS_ROUTER_PATH,
  PRIVACY_ROUTER_PATH,
  COMPANY_ROUTER_PATH,
  RESUME_LANDING_ROUTER_PATH,
  CULTURAL_RESULT_ROUTER_PATH,
  RECORD_URL,
  SITEMAP_ROUTER_PATH,
} from '@/constants/router-path';
import { getYear } from '@/utils/datetime';

const Footer = (props: {
  setFooterMargin?: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { setFooterMargin } = props;
  const isMobile = useClintMediaQuery();
  const { isLogin } = React.useContext(AuthContext);

  const measuredRef = React.useCallback(
    (node: Element) => {
      if (node !== null) {
        const marginTop = parseInt(
          window?.getComputedStyle(node)?.marginTop || '0px',
        );
        setFooterMargin?.(marginTop + 'px');
      }
    },
    [isMobile],
  );

  const footerLabels: {
    labelsName: string;
    labels: {
      labelName: string;
      labelUrl?: string;
      props?: Record<string, string | unknown>;
    }[];
  }[] = [
    {
      labelsName: '谈职',
      labels: [
        {
          labelName: '职场数据',
          labelUrl: HOME_PAGE_ROUTER_PATH,
        },
        {
          labelName: '线上简历',
          labelUrl: isLogin
            ? CANDIDATES_ME_ROUTER_PATH
            : RESUME_LANDING_ROUTER_PATH,
        },
        {
          labelName: '文化偏好',
          labelUrl: isLogin
            ? CULTURAL_RESULT_ROUTER_PATH
            : CULTURAL_ROUTER_PATH,
        },
        {
          labelName: '关于谈职',
          labelUrl:
            COMPANY_ROUTER_PATH + 'd9759106-93be-4f76-9899-abec64b0e8c3/',
        },
      ],
    },
    {
      labelsName: '使用与帮助',
      labels: [
        {
          labelName: '用户协议',
          labelUrl: TERMS_ROUTER_PATH,
        },
        {
          labelName: '隐私政策',
          labelUrl: PRIVACY_ROUTER_PATH,
        },
        {
          labelName: '网站地图',
          labelUrl: SITEMAP_ROUTER_PATH,
        },
      ],
    },
    {
      labelsName: '联系方式',
      labels: [
        {
          labelName: 'contact@tanzhi.cn',
          labelUrl: 'mailto:contact@tanzhi.cn',
        },
      ],
    },
  ];

  return (
    <Box
      className="bg-web-grey-100 mt-25 min-w-50"
      ref={measuredRef}
      component="footer"
    >
      <div className="grid grid-cols-2 justify-center w-full h-auto py-5 px-10 tablet:flex tablet:h-[265px] tablet:pb-0 tablet:pt-10 tablet:px-0">
        {footerLabels.map((labels, index) => {
          return (
            <div
              className="whitespace-nowrap mb-12 mr-0 first:min-w-[152px] [&:nth-of-type(2)]:ml-auto last:mr-0 last:mb-0 tablet:mr-[280px] tablet:mb-0 tablet:first:min-w-0 tablet:[&:nth-of-type(2)]:ml-0"
              key={labels.labelsName}
            >
              <p className="text-xl font-semibold inline-block mb-5 tablet:text-2xl">
                {labels.labelsName}
              </p>
              <ul
                className={`list-none ml-0 ${
                  index === 0 ? 'flex flex-wrap tablet:block' : ''
                }`}
              >
                {labels.labels?.map((label) => (
                  <li
                    className="list-none text-sm mb-3 mr-5 tablet:mr-0"
                    key={label.labelName}
                  >
                    {label?.labelUrl ? (
                      <Link href={label.labelUrl}>{label.labelName}</Link>
                    ) : (
                      label.labelName
                    )}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
      <div className="text-center border-t border-white h-[55px]">
        <p className="h-full text-center flex justify-center items-center flex-wrap gap-x-4">
          <span>Copyright © {getYear()} tanzhi.cn</span>
          <Link href={RECORD_URL} target="_blank" rel="noopener,noreferrer">
            苏ICP备2023000726号-1
          </Link>
          <span>苏B2-20230605</span>
        </p>
      </div>
    </Box>
  );
};

export default Footer;
